
export type ModuleLegacyCustomSettingSectionPosition = 'top' | 'bottom' | 'above-groups';
export enum ModuleCustomSettingSectionType {
    Legacy,
    Slideout,
    CxOne,
}

export interface IModuleCustomSettingSection {
    type: ModuleCustomSettingSectionType;
    after?: string;
    inside?: string;
    position?: ModuleLegacyCustomSettingSectionPosition; // for legacy
    getNativeElement(): HTMLElement;
}
